import {fetchWithState, getFetchedJSON, fetchWithMessage} from '~/misc/fetch';


export const getCatalogs = (getState) => {
  return fetchWithState(getState, {
    method: 'GET',
    url: `/tl/appmsg/catalogs`,
  }).then(getFetchedJSON);
};

export const deleteCatalogs = (getState, type) => {
  return fetchWithState(getState, {
    method: 'DELETE',
    url: `/tl/appmsg/catalogs/delete/${type}`,
  }).then(getFetchedJSON);
};

export const readCatalogs = (getState, type) => {
  return fetchWithState(getState, {
    method: 'PUT',
    url: `/tl/appmsg/catalogs/read?mainType=${type}`,
  }).then(getFetchedJSON);
};

export const getMessage = (getState, {type, msgId = ''}) => {
  return fetchWithState(getState, {
    method: 'GET',
    url: `/tl/appmsg/catalogs/${type}/messages?pageSize=200&msgId=${msgId}`,
  }).then(getFetchedJSON);
};

export const deleteMessage = (getState, msgId) => {
  return fetchWithState(getState, {
    method: 'DELETE',
    url: `/tl/appmsg/messages/${msgId}`,
  }).then(getFetchedJSON);
};

export const getToken = (getState) => {
  return fetchWithMessage(getState, {
    method: 'GET',
    url: `/message-center/token`,
  }).then(getFetchedJSON);
}




// WEBPACK FOOTER //
// ./src/pages/MessagePush/state/api.js